var map = {
	"./a.svg": 7679,
	"./a_white.svg": 5017,
	"./adr.svg": 561,
	"./adr_white.svg": 1131,
	"./am.svg": 1320,
	"./am_white.svg": 5250,
	"./b.svg": 8652,
	"./b_white.svg": 3670,
	"./be.svg": 1337,
	"./be_white.svg": 99,
	"./c.svg": 7197,
	"./c1.svg": 5782,
	"./c1_white.svg": 8584,
	"./c1e.svg": 4071,
	"./c1e_white.svg": 3745,
	"./c_white.svg": 4023,
	"./ce.svg": 8106,
	"./ce_white.svg": 4188,
	"./d.svg": 3266,
	"./d1.svg": 4863,
	"./d1_white.svg": 3545,
	"./d1e.svg": 6992,
	"./d1e_white.svg": 9642,
	"./d_white.svg": 1492,
	"./lmv.svg": 2759,
	"./lmv_white.svg": 1297,
	"./lt.svg": 8090,
	"./lt_white.svg": 5980,
	"./m.svg": 891,
	"./m_white.svg": 7605,
	"./olb.svg": 9359,
	"./olb_white.svg": 6041,
	"./t.svg": 7410,
	"./t_white.svg": 4500,
	"./taxi.svg": 2870,
	"./taxi_white.svg": 920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7820;